import { render, staticRenderFns } from "./agent-authorizations.vue?vue&type=template&id=b0385204&scoped=true"
import script from "./agent-authorizations.vue?vue&type=script&lang=js"
export * from "./agent-authorizations.vue?vue&type=script&lang=js"
import style0 from "./agent-authorizations.vue?vue&type=style&index=0&id=b0385204&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0385204",
  null
  
)

export default component.exports